import {useContext, useState} from "react";
import {CountContext, OrderContext} from "../states/MyContext";

export const Modal = ({closeModal, clearCart}) => {
    const [showOrderId, setShowOrderId] = useState(false);
    const [orderId, setOrderId] = useState(null);
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const {orderButtonClick, cartData} = useContext(OrderContext);
    const  { priceAmount, itemCount } = useContext(CountContext)
    const style = {
        position: 'absolute',
        top: '50px',
        padding: '20px',
        margin: 'auto',
        width: '50%',
        backgroundColor: '#d40000',
        zIndex: '10'
    }

    // handleSubmit   Отправить форму на сервер.....
        const handleSubmit = (event) => {
            event.preventDefault(); // Prevent default form submission

            const formData = {
                id: event.target.elements.id.value, // Get the value of the hidden input field
                name: event.target.elements.name.value,
                email: event.target.elements.email.value,
                phone: event.target.elements.phone.value,
                cartData,
                itemCount,
            };
            console.log(formData)
            fetch('/cart-submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json' // Set the content type to JSON
                },
                body: JSON.stringify(formData) // Convert data to JSON string
            }).then((response) => {
                    if (response.ok) {
                        return response.json(); // Parse JSON response
                    } else {
                        throw new Error('Server error'); // Handle non-200 status codes
                    }
                }) // Parse JSON response
                .then((data) => {
                    // Handle successful response
                    setSuccess(!success);
                    console.log('Success:', data);
                })
                .catch((error) => {
                    // Handle error
                    console.error('Error:', error);
                });
            };



        return (

        <div style={style} className="modal__contnent form__content">
            <div onClick={() => closeModal()} className="modal__button-close">
                <span className="close">X</span>
            </div>
            <h3>Fill out the form to place your order.</h3>
            <p>We will contact you shortly.</p>
            { success ?
                <div className='form form__content'>
                <p>SUCCESS</p>
                <p>Your order Amount: {priceAmount} $.</p>
                <p>Thank you for your order!</p>
                </div> :
            <form onSubmit={handleSubmit} action="cart-submit" className='form form-order' >
                <input className="form__input" type="hidden" name="id" value="0"/>
                <label className="form__label">Name</label>
                <input className="form__input" name="name" type="text" placeholder="Name"/>
                <label className="form__label">Phone</label>
                <input className="form__input" type="phone" name="phone" placeholder="380 ___ __ __"/>
                <label className="form__label">Email</label>
                <input className="form__input" type="email" name="email" placeholder="__@__._"/>
                <button className="button form__button modal__btn-submit" id="Btn" type="submit">Submit</button>
                <div className="modal__content form__content">
                    <p>Arcadia Cycling Club - it is a cycling team of Arcadia Club Odessa-Ukraine.
                        It was founded in 2000 of International Level
                        Club Unites amateur athletes, professional athletes.
                        Club Members representing the team in several disciplines such as road bike, cyclocross, gravel
                        and mountain bike.</p>
                </div>
            </form>}
            <div onClick={() => orderButtonClick()} className="button pay-btn">
                <span>Pay Now</span>
            </div>
        </div>

    )
}
